export default __webpack_public_path__ + "static/media/2018 (2).7cc4bbd7.JPG";